$ () ->
    $.widget 'custom.listitems',

        options:
            createMessageWriter: true
            message_writer: null
            createMultiDelete: true
            listUrl: null
            listOptions: {}
            listCallback: () -> undefined
            template: null


        _create: () ->
            if @options.createMessageWriter
                @options.message_writer = +new Date() if not @options.message_writer
                @_createMessageWriter()


        _setOption: () ->
            undefined

        destroy: () ->
            undefined

        list: () ->
            opts = @options
            msgWriter = $(opts.message_writer)

            if opts.message_writer?
                msgWriter.message_writer()
                msgWriter.message_writer 'info', 'Loading...'

            $.post opts.listUrl, opts.listOptions, (response) =>
                if opts.message_writer?
                    msgWriter.message_writer 'write', response
                    msgWriter.message_writer 'hide'

                if opts.template?
                    html = $(opts.template).render(response.data)
                else
                    html = response
                @element.find('tbody').append(html)

                opts.listCallback @element, response


        _createMessageWriter: () ->
            @element.after("<div class='message_writer' id='#{@options.message_writer}'")


        _removeMessageWriter: () ->
            $(@options.message_writer).remove()
